module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CI - Côte d'Ivoire.ab5823f4.svg";